import type { FilterId } from '../../common/types/filters';

/**
 * Universal filter IDs that are always included for every product.
 * Mirrors search-page behavior: lastUpdated, universalTypeFilter, contributor.
 */
export const UNIVERSAL_FILTER_IDS: readonly FilterId[] = [
	'lastUpdated',
	'universalTypeFilter',
	'contributor',
] as const;
